<div class="book-event-slot-subheader">
  {{ "APP.BOOK_EVENT_SLOT.CHOOSE_TICKET_CATEGORY" | translate }}
</div>
<div class="book-event-slot-cards">
  @for (ticket of tickets; track ticket.id) {
    <div
      class="book-event-slot-card"
      [class.disabled-card]='isBeforeStartSale(ticket)'
      [class.selected]="chosenTicket && chosenTicket.id === ticket.id"
      (click)="chooseTicket(ticket)"
    >
      <div class="card-content">
        <div class="card-title">
          {{ ticket.name }} | {{ ticket.getDisplayPrice() }}/{{
            "APP.BOOK_EVENT_SLOT.SLOT" | translate
          }}
        </div>
         <div class="card-desc">
           <div class="price-wrapper">
             <div class="ticket-sales-info">
                 <div
                   class="sale-info"
                   [class.hidden]="!ticket.showSalesDeadlineAndStatusDuringOrder"
                 >
                   @if (isBeforeStartSale(ticket)) {
                     <div class="normal">
                       {{ "APP.TICKETING.SALE_STARTS_ON" | translate }}
                       {{ ticket.saleStartDate | date: "dd.MM.yyyy HH:mm" }}
                     </div>
                   } @else if (checkIfSoldOut(ticket)) {
                     <div class="highlighted">
                       {{ "APP.TICKETING.SOLD_OUT" | translate }}
                     </div>
                   } @else if (ticket.getNumAvailableTickets() < 10) {
                     <div class="highlighted">
                       {{ "APP.TICKETING.FEW_TICKETS_LEFT" | translate }}
                     </div>
                   } @else if (ticket.saleEndDate) {
                     <div class="normal">
                       {{ "APP.TICKETING.SALE_ENDS_ON" | translate }}
                       {{ ticket.saleEndDate | date: "dd.MM.yyyy HH:mm" }}
                     </div>
                   }
                 </div>
             </div>
           </div>
         </div>
      </div>
      @if (ticket.description && !isBeforeStartSale(ticket)) {
        <div
          class="card-info"
          [matTooltip]="ticket.description"
          [matTooltipPosition]="'above'"
          matTooltipClass="menu-item-tooltip"
        >
          <i class="far fa-circle-info icon-regular"></i>
        </div>
      }
    </div>
  }
</div>
